import React from "react";
import PropTypes from "prop-types";
import { NavLink, HashRouter } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CancelButtonLink } from "../../../components/Buttons";
import {
  WizardTitle,
  notifyError,
  PageHeightAuto,
  notifyInfo,
  CoverText,
  PageHeight20,
} from "../../../components/Utils";
import Dashboard from "../../../components/Dashboard";
import ImportForm from "../../../components/ImportForm";
// import { reasonTemplate } from "../../Reporting/components/RecordsTable";

class WorkerImportWizard extends React.Component {
  static propTypes = {
    history: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      imported: null,
      rejected: null,
      isNewProfile: false,
      isChangeProfile: false,
      importSuccess: false,
    };
  }

  componentDidUpdate() {
    if (this.state.importSuccess) {
      const isNew  = this.props.type === "neu";
      const summary = `Mitarbeiter Importieren`;
      setTimeout(() => {
        notifyInfo({
          summary,
          detail: `Die Mitarbeiter  wurden erfolgreich importiert.`,
        });
        this.handleCancel();
      }, 2000);
    }
  }

  handleError = (event) => {
    const error = event.xhr.response;
    const errorMessage = error && error.message;
    notifyError({
      summary: "Importfehler",
      detail: errorMessage,
    });
    this.setState({ imported: [], rejected: [] });
  };

  handleSuccess = (event) => {
    console.log("Import succeeded:", event);
    /* //===================================//
    // temporary solution
    this.setState({ importSuccess: true });
    //===================================// */
    const { imported, rejected, totalEmployees, isNewProfile, isChangeProfile } = event.xhr.response;
    this.setState({
      imported,
      // to keep the `rejected` structure similar to the `imported` structure
      rejected: rejected.map(
        ({ record, ...other }) => ({ ...record, ...other})
      ),
      isNewProfile,
      isChangeProfile,
      totalEmployees,
    });
  };

  handleCancel = () => {
    const { history } = this.props;
    history.push("/organisation/mitarbeiter");
  };
  renderMenu() {
    const { imported, rejected } = this.state;
    let rejectedLink;
    if (rejected) {
      rejectedLink = (
        <li>
          <NavLink to={`/abgelehnt`} activeClassName="active">
            {"Abgelehnt"}
          </NavLink>
        </li>
      );
    }
    let importedLink;
    if (imported) {
      importedLink = (
        <li>
          <NavLink to={`/importiert`} activeClassName="active">
            {"Importiert"}
          </NavLink>
        </li>
      );
    }
    return (
      <HashRouter>
        <div className="under-wizard-title">
          <div className="margin-big-top nav-menu-vertical">
            <ul className="w3-ul w3-border w3-round- w3-large">
              <li>
                <NavLink to={`/upload`} activeClassName="active">
                  {"CSV hochladen"}
                </NavLink>
              </li>
              {importedLink}
              {rejectedLink}
            </ul>
          </div>
        </div>
      </HashRouter>
    );
  }
  renderImported = (records, totalEmployees) => {
    if (records === null) {
      return null;
    }
    const isUpdating = this.state.isChangeProfile === true;
    let message = <>{`Keine importierten Mitarbeiter`}</>;
    if (records.length > 0) {
      message = (
        <>
          <b>{`${records.length} von ${totalEmployees} Mitarbeiter`}</b>
          {` wurde${records.length > 1 ? "n" : ""} erfolgreich ${isUpdating ? "angepasst" : "neu angelegt"}.`}
        </>
      );
    }
    return (
      <PageHeight20
        id="/importiert"
        className="w3-border margin-big-top pad-big"
        isUnterWizardTitle
      >
        <h3 className="no-margin-top">{`Erfolgreiche ${isUpdating ? "Änderungen" : "Neuanlagen"}`}</h3>
        <PageHeight20>
          <CoverText>
            <h4 className="no-margin display-inline">
              {message}
            </h4>
          </CoverText>
        </PageHeight20>
      </PageHeight20>
    );
  }
  renderRejected = (records) => {
    if (records === null) {
      return null;
    }
    const isUpdating = this.state.isChangeProfile === true;
    let markup = (
      <CoverText>
        <h4 className="no-margin display-inline">
          {`Keine abgelehnten Mitarbeiter`}
        </h4>
      </CoverText>
    );
    if (records.length > 0) { // 
      const items = records.map((record) => {
        const copy = {
          ...record,
          contractGiver: record["KDL / DL"],
        };
        if (record.Vorname) {
          copy.employee = `${record.Vorname} ${record.Nachname}`;
        }
        if (record.Mitarbeiterprofil) {
          copy.username = record.Mitarbeiterprofil;
        }
        return copy;
      });
      const columnStyle = {
        verticalAlign: "top",
        paddingTop: "16px",
        paddingBottom: "16px",
      };
      markup = (
        <DataTable
          value={items}
          className="records-table"
          paginator
          rows={10}
        >
          {/* <Column field="info.lines" header="Zeile" /> */}
          <Column
            field="contractGiver"
            header="Servicepartner"
            style={{ ...columnStyle, width: "20em" }}
          />
          {isUpdating ? (
            <Column
              field="username"
              header="Mitarbeiter"
              style={{ ...columnStyle, width: "20em" }}
            />
          ) : (
            <Column
              field="employee"
              header="Mitarbeiter"
              style={{ ...columnStyle, width: "20em" }}
            />
          )}
          <Column
            field="errors"
            header="Fehlermeldungen"
            style={columnStyle}
            body={(item) => (
              <>
                {item.errors.map((value, index) => (
                  <label key={`error${index}`} className="w3-block">{value}</label>
                ))}
              </>
            )}
          />
        </DataTable> 
      );
    }
    return (
      <PageHeightAuto
        id="/abgelehnt"
        className="w3-border margin-big-top pad-big"
        isUnterWizardTitle
      >
        <h3 className="no-margin-top">{`Abgelehnte ${isUpdating ? "Änderungen" : "Neuanlagen"}`}</h3>
        <PageHeight20>{markup}</PageHeight20>
      </PageHeightAuto>
    );
  };

  render() {
    // const { type } = this.props;
    const { imported, rejected, totalEmployees } = this.state;
    console.log(
      "WorkerImportWizard.render() \nprops",
      this.props,
      "\nstate",
      this.state
    );
    const Menu = this.renderMenu();
    const rejectedSection = this.renderRejected(rejected);
    const importedSection = this.renderImported(imported, totalEmployees);

    return (
      <div className="clearfix">
        <WizardTitle
          type={`worker-import`}
          menu={
            <div className="pad-big-top">
              <CancelButtonLink onCancel={this.handleCancel} />
            </div>
          }
        />
        <div className="container">
          <Dashboard menu={Menu} menuSize={3}>
            <PageHeightAuto
              id="/upload"
              className="w3-border margin-big-top pad-big"
              isUnterWizardTitle
            >
              <h3 className="no-margin-top">CSV hochladen</h3>
              <ImportForm
                url={`/data-api/companies/employees/import/csv`}
                onError={this.handleError}
                onUpload={this.handleSuccess}
                // disabled={imported !== null || rejected !== null}
              />
            </PageHeightAuto>
            {importedSection}
            {rejectedSection}
          </Dashboard>
        </div>
      </div>
    );
  }
}

export default WorkerImportWizard;
